import { createSelector } from 'reselect';
import { ITouchpoint, ITouchpointGroup, ITouchpointType, ITouchpointsState } from './types';

export const selectLoadedState = (state: ITouchpointsState) => state.loaded;
export const selectTouchpoints = (state: ITouchpointsState) => state.touchpoints;
export const selectTouchpointGroups = (state: ITouchpointsState) => state.touchpointGroups;
export const selectTouchpointTypes = (state: ITouchpointsState) => state.touchpointTypes;
export const selectSyncError = (state: ITouchpointsState) => state.error;
export const selectSyncState = (state: ITouchpointsState) => !!state.syncing;

export const selectIndexedTouchpoints = createSelector(selectTouchpoints, (touchpoints) =>
  touchpoints.reduce((indexed: { [key: string]: ITouchpoint }, touchpoint: ITouchpoint) => {
    if (touchpoint.id) {
      indexed[touchpoint.id] = touchpoint;
    }
    return indexed;
  }, {})
);
export const selectTouchpoint = createSelector(
  [selectIndexedTouchpoints, (_: ITouchpointsState, id: string) => id],
  (indexedTouchpoints, id) => indexedTouchpoints[id]
);

export const selectIndexedTouchpointGroups = createSelector(
  selectTouchpointGroups,
  (touchpointGroups) =>
    touchpointGroups.reduce(
      (indexed: { [key: string]: ITouchpointGroup }, touchpointGroup: ITouchpointGroup) => {
        if (touchpointGroup.touchpointGroupId) {
          indexed[touchpointGroup.touchpointGroupId] = touchpointGroup;
        }
        return indexed;
      },
      {}
    )
);

export const selectTouchpointGroup = createSelector(
  [selectIndexedTouchpointGroups, (_: ITouchpointsState, id: string) => id],
  (indexedTouchpointGroups, id) => indexedTouchpointGroups[id]
);

export const selectIndexedTouchpointTypes = createSelector(
  selectTouchpointTypes,
  (touchpointTypes) =>
    touchpointTypes.reduce(
      (indexed: { [key: string]: ITouchpointType }, touchpointType: ITouchpointType) => {
        if (touchpointType.id) {
          indexed[touchpointType.id] = touchpointType;
        }
        return indexed;
      },
      {}
    )
);
